import { BrowserRouter, Route, Routes,Navigate} from "react-router-dom";
import Home from "./pages/Home";
import BarbarDetail from "./pages/BarbarDetail";
import Login from "./Auth/Login/Login";
import Signup from "./Auth/Signup/Signup";
import Barbar from "./Barbars/Barbar";
import Thanks from "./pages/Thanks";
import AdminLogin from "./Auth/AdminLogin/Login";
import Appointment from "./Appointment/Appointment";
import './App.css'

function App() {

 
  return (
    <>
      <BrowserRouter>
        <Routes>
        <Route exact path="/" element={<Navigate to="/barbar"/>} />
          
          <Route exact path="/barbar" element={<Home />} />
          <Route exact path="/detail/:id" element={<BarbarDetail />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/admin/login" element={<AdminLogin />} />
          <Route exact path="/signup" element={<Signup />} />
          <Route exact path="/barbars" element={<Barbar />} />
          <Route exact path="/thanks" element={<Thanks />} />
          <Route exact path="/appointment" element={<Appointment />} />

        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
